<template>
  <div class="cc-tool">
    <div class="editor-pane">
      <div class="pane-header"><span class="pane-dot input-dot" /><span class="pane-label">{{ $t('tool.CharCount.title') }}</span><span class="pane-hint">{{ $t('tool.CharCount.hint') }}</span></div>
      <el-input v-model="text" type="textarea" :rows="12" :placeholder="$t('tool.CharCount.phInput')" class="code-textarea" />
    </div>
    <div class="cc-stats">
      <div class="cc-stat">
        <div class="cc-stat-val">{{ stats.chars }}</div>
        <div class="cc-stat-lbl">{{ $t('tool.CharCount.totalChars') }}</div>
      </div>
      <div class="cc-stat">
        <div class="cc-stat-val">{{ stats.charsNoSpace }}</div>
        <div class="cc-stat-lbl">{{ $t('tool.CharCount.charsNoSpace') }}</div>
      </div>
      <div class="cc-stat">
        <div class="cc-stat-val">{{ stats.words }}</div>
        <div class="cc-stat-lbl">{{ $t('tool.CharCount.wordCount') }}</div>
      </div>
      <div class="cc-stat">
        <div class="cc-stat-val">{{ stats.lines }}</div>
        <div class="cc-stat-lbl">{{ $t('tool.CharCount.lineCount') }}</div>
      </div>
      <div class="cc-stat">
        <div class="cc-stat-val">{{ stats.cnChars }}</div>
        <div class="cc-stat-lbl">{{ $t('tool.CharCount.cnCharCount') }}</div>
      </div>
      <div class="cc-stat">
        <div class="cc-stat-val">{{ stats.bytes }}</div>
        <div class="cc-stat-lbl">{{ $t('tool.CharCount.bytesUTF8') }}</div>
      </div>
      <div class="cc-stat">
        <div class="cc-stat-val">{{ stats.sentences }}</div>
        <div class="cc-stat-lbl">{{ $t('tool.CharCount.sentenceCount') }}</div>
      </div>
      <div class="cc-stat">
        <div class="cc-stat-val">{{ stats.paragraphs }}</div>
        <div class="cc-stat-lbl">{{ $t('tool.CharCount.paragraphCount') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'CharCountTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({text:''}),
  computed:{
    stats(){
      const t=this.text||''
      const chars=t.length
      const charsNoSpace=t.replace(/\s/g,'').length
      const words=t.trim()?t.trim().split(/\s+/).length:0
      const lines=t?t.split(/\n/).length:0
      const cnChars=(t.match(/[一-鿿㐀-䶿]/g)||[]).length
      const bytes=new Blob([t]).size
      const sentences=t?t.split(/[。！？.!?\n]+/).filter(s=>s.trim()).length:0
      const paragraphs=t?t.split(/\n\s*\n/).filter(p=>p.trim()).length:0
      return {chars,charsNoSpace,words,lines,cnChars,bytes,sentences,paragraphs}
    }
  },
  methods:{doAction(a){if(a==='clear')this.text='';if(a==='copy'){navigator.clipboard.writeText(this.text);this.$message.success(this.$t("common.status.copied"))};if(a==='paste'){navigator.clipboard.readText().then(t=>{this.text=t})}}}
}
</script>

<style scoped>
.cc-tool { display:flex;flex-direction:column;gap:14px; }
.editor-pane { background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px; }
.pane-header { display:flex;align-items:center;gap:8px;margin-bottom:12px; }
.pane-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0; }
.input-dot { background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4); }
.pane-label { font-size:13px;font-weight:700;color:#1a1f36; }
.pane-hint { font-size:11px;color:#b0b8c4;margin-left:auto; }
.code-textarea >>> textarea { font-family:'JetBrains Mono','Consolas',monospace!important;font-size:13px!important;border-radius:8px;resize:none; }

.cc-stats { display:grid;grid-template-columns:repeat(4,1fr);gap:10px; }
.cc-stat { background:#fff;border-radius:10px;padding:14px 16px;text-align:center;border:1px solid #ebeef5; }
.cc-stat-val { font-size:22px;font-weight:700;color:#4e7cff;font-family:monospace; }
.cc-stat-lbl { font-size:11px;color:#8892a6;margin-top:2px; }
@media(max-width:560px){.cc-stats{grid-template-columns:repeat(2,1fr);}}
</style>
